import SeoLandingPage from "@/components/SeoLandingPage";

const CommercialPropertyCleanout = () => (
  <SeoLandingPage
    slug="commercial-property-cleanout-wi"
    metaTitle="Commercial Property Cleanout Wisconsin | Office, Retail, Warehouse"
    metaDescription="Commercial property cleanout in Wisconsin. Office, retail, warehouse, restaurant trash-outs. After-hours service available. Free estimate."
    h1="Commercial Property Cleanouts in Wisconsin"
    heroImage="/images/garage.jpg"
    heroIntro="Closing a location, ending a lease, or taking over a commercial space? We clear offices, retail stores, restaurants, and warehouses across Wisconsin — including evenings and weekends so you don't lose business hours."
    serviceName="Commercial Property Cleanout"
    bullets={[
      "Office furniture, cubicles, filing cabinets, and copiers hauled away.",
      "Restaurant equipment removal: walk-ins, hoods, fryers, ice machines.",
      "Retail fixtures, racks, mannequins, and POS equipment.",
      "Warehouse pallet racking, conveyors, and bulk material clear-out.",
      "Secure document shredding coordination through certified partners.",
      "After-hours and weekend service so storefronts stay open.",
    ]}
    whyUs={[
      "Insured to $1M for commercial liability in Wisconsin.",
      "COIs available within hours for property managers and landlords.",
      "We work around your business — early mornings, evenings, weekends.",
      "Loading-dock and freight-elevator experienced; we know commercial buildings.",
    ]}
    processSteps={[
      { title: "Site walkthrough", detail: "In-person or virtual walkthrough so we can scope the right truck size and crew." },
      { title: "Quote & schedule", detail: "Written quote within one business day. We schedule around your operating hours." },
      { title: "Clear and clean", detail: "Crew removes everything per scope. Recyclables and donations diverted from landfill." },
      { title: "Lease-ready handoff", detail: "Space left broom-clean and ready for landlord walkthrough or new tenant." },
    ]}
    faqs={[
      { q: "Can you work after-hours?", a: "Yes. We regularly work nights and weekends for retail and restaurant clients in Wisconsin so the business doesn't lose hours." },
      { q: "Do you provide a Certificate of Insurance?", a: "Yes. We carry $1M general liability and can have a COI sent to your landlord or property manager within hours." },
      { q: "Can you handle restaurant equipment?", a: "Yes. We remove walk-in coolers, hoods, fryers, ovens, and ice machines. Refrigerant is reclaimed by a licensed technician where required." },
      { q: "What about confidential documents?", a: "We coordinate with NAID-certified shredding partners and can provide a certificate of destruction for sensitive paperwork." },
    ]}
    ctaHeadline="Need the space empty by month-end?"
  />
);

export default CommercialPropertyCleanout;
